export default "__VITE_ASSET__BzQ1yhm9__"